import PublisherConfig from "@/configs/publisher.json";

export const OWNER_SUBSCRIBE_ERROR = "You cannot subscribe to your own publication.";

export function emailsEqual(left: string, right: string): boolean {
  return left.trim().toLowerCase() === right.trim().toLowerCase();
}

export function getPublisherOwnerEmail(): string | null {
  const email = (PublisherConfig as { email?: unknown }).email;
  return typeof email === "string" && email.trim() ? email.trim() : null;
}

export function isPublisherOwnerEmail(email: string): boolean {
  const ownerEmail = getPublisherOwnerEmail();
  return !!ownerEmail && emailsEqual(ownerEmail, email);
}
